import { toBaseFormId } from 'components/IAP/formFamily';
import { WIDGET_TITLES } from 'components/IAP/planningView/USCGPage';

/** The workspace card that authors an ICS form, by form name. */
export function widgetNameForIcsForm(formName: string): string {
  const token = toBaseFormId(formName)
    .replace(/^ICS_/, '')
    .replace(/_/g, '')
    .toUpperCase();
  const marker = `ICS${token}`;
  const matches = WIDGET_TITLES.flatMap((widget) => {
    const compact = widget.title.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    const at = compact.indexOf(marker);
    if (at < 0) return [];
    const after = compact.slice(at + marker.length);
    return [{ widgetName: widget.widgetName, exact: !/^[A-Z]/.test(after) }];
  });
  return (
    matches.find((match) => match.exact)?.widgetName ??
    matches[0]?.widgetName ??
    formName
  );
}
